import { Box } from '@mui/material';
import React from 'react';

// Visual variants for the toolbar shell.  The default `elevated`
// variant is the standalone-page chrome — bordered surface, shadow,
// rounded corners, page-gap below — used when the toolbar sits at the
// top of a list page (UserGrid, customer grid, PrepaidCoverageGrid).
// `flat` strips the shell down to a flush row with no border / bg /
// shadow / margin — for toolbars embedded inside another container's
// chrome (settings sections, sub-tabs) where the surrounding card
// already supplies the surface.
//
// Both variants share padding + flex layout so the toolbar internals
// (search field, action buttons) stay identical in size and rhythm.
const VARIANT_SX = {
  elevated: {
    bgcolor: 'var(--grid-toolbar-bg)',
    border: '1px solid var(--grid-toolbar-border)',
    borderRadius: 'var(--grid-toolbar-radius)',
    boxShadow: 'var(--shadow-sm)',
    mb: 'var(--page-gap)',
  },
  flat: {
    bgcolor: 'transparent',
    border: 0,
    borderRadius: 0,
    boxShadow: 'none',
    mb: 1,
    px: 0,
  },
};

export default function DataGridToolbarShell({ children, variant = 'elevated', sx }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 'var(--toolbar-gap)',
        width: '100%',
        px: 'var(--grid-toolbar-px)',
        py: 'var(--grid-toolbar-py)',
        ...VARIANT_SX[variant],
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
